import React, { useEffect, useRef, useState } from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import { FaGears, FaHandHoldingHeart, FaLeaf } from 'react-icons/fa6';


const HomepageComp3 = () => {

  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container2 homepage-comp3-container flex justify-center  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div className='homepage-comp3-div1 mt-4'>
        <h1 className='homepage-title2'>Discover Our Unique <span class="rounded-full bg-[#1E3F20] px-3 py-2 text-white">Mining</span> Advantages</h1>
 
        <div className='grid grid-cols-2 gap-12 mt-6'>
          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <FaLeaf className='' />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>Eco-Friendly Mining Techniques</h2>
              <p className='homepage-text2'>Participate in our proactive efforts to engage in environmentally safe mining practices that protect local ecosystems while expertly extracting gold.</p>
            </div>
          </div>
          
          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <FaGears className='' />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>Advanced Mining Technology</h2>
              <p className='homepage-text2'>Leverage cutting-edge machinery to maximize efficiency and ensure responsible mining practices, adhering to the highest standards of safety.</p>
            </div>
          </div>
        </div>

        <div className='grid grid-cols-2 gap-12 mt-6'>
          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <FaHandHoldingHeart className='' />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>Empowering Local Communities</h2>
              <p className='homepage-text2'>Drive positive impact by supporting local jobs and initiatives that foster community development through our mining operations.</p>
            </div>
          </div>

          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <FaShieldAlt className='' />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>Commitment to Safety and Compliance</h2>
              <p className='homepage-text2'>Rest assured with our dedication to safety regulations and practices, providing a secure environment for both our teams and the environment.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="parallax-container relative z-3">
        <div class="parallax-box"></div>
      </div>

    </div>
  )
}

export default HomepageComp3